export const MATERIALS = {
  R: 0xf0165b,
  O: 0xfc6800,
  Y: 0xffee00,
  G: 0x4bbd57,
  B: 0x4287f5,
  W: 0xfafafa,
  K: 0x222222,
  H: 0x42ffec,
  T: 0x555555,
  N: 0x333333
};
MATERIALS.RED = MATERIALS.R;
MATERIALS.ORANGE = MATERIALS.O;
MATERIALS.YELLOW = MATERIALS.Y;
MATERIALS.GREEN = MATERIALS.G;
MATERIALS.BLUE = MATERIALS.B;
MATERIALS.WHITE = MATERIALS.W;
MATERIALS.BLACK = MATERIALS.K;
MATERIALS.BLANK = MATERIALS.N;
MATERIALS.TINTED = MATERIALS.T;
MATERIALS.HIGHLIGHTED = MATERIALS.H;
